import React from "react"

export const NotAllowedSvg = ({ width, height, color }) => (
  <svg width={width ?? "10"} height={height ?? "11"} viewBox="0 0 10 11" fill={color ?? "#9EACB0"} xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.93863 10.5101C7.60198 10.5101 9.76105 8.351 9.76105 5.68765C9.76105 3.02431 7.60198 0.865234 4.93863 0.865234C2.27528 0.865234 0.116211 3.02431 0.116211 5.68765C0.116211 8.351 2.27528 10.5101 4.93863 10.5101ZM4.93863 9.56658C2.79636 9.56658 1.0597 7.82993 1.0597 5.68765C1.0597 3.54538 2.79636 1.80872 4.93863 1.80872C7.0809 1.80872 8.81756 3.54538 8.81756 5.68765C8.81756 7.82993 7.0809 9.56658 4.93863 9.56658Z" />
    <rect x="0.723633" y="7.52222" width="9.02775" height="0.996262" transform="rotate(-30 0.723633 7.52222)" />
  </svg>



)